/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useModalContext } from '@context/ModalContext/ModalContext'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { Button } from '@components/common/AutoWidgetButton/button'
import { ButtonType } from '@enums/ButtonType'
import styles from './button.module.scss'

export const BlackCta = ({ data, segmentEventCommonProperties, onClick }) => {
  const { setShow } = useModalContext()

  const onButtonClick = () => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      trackEvent('tap_btn_CTA_widget', {
        ...properties,
        funnel: 'entry',
        cta: 'Check Savings-sticky_cta',
      })
    })()

    if (onClick) {
      onClick()
    } else if (data.link) {
      window.open(data.link, '_blank')
    } else {
      setShow(true)
    }
  }
  if (data && Object.keys(data).length !== 0) {
    return <Button onClick={onButtonClick} ctaText={data.name} type={ButtonType.Black} />
  }
  return null
}
export const FloatingCta = ({ data, segmentEventCommonProperties, onClick }) => {
  const { setShow } = useModalContext()

  const onButtonClick = () => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      trackEvent('tap_btn_CTA_widget', {
        ...properties,
        funnel: 'entry',
        cta: 'Check Savings-sticky_cta',
      })
    })()

    if (onClick) {
      onClick()
    } else if (data.link) {
      window.open(data.link, '_blank')
    } else {
      setShow(true)
    }
  }
  if (data && Object.keys(data).length !== 0) {
    return <Button onClick={onButtonClick} ctaText={data.name} type={ButtonType.BlackFloating} />
  }
  return null
}

const NColumnGridCta = ({ data, segmentEventCommonProperties, onClick }) => {
  const { setShow } = useModalContext()

  const onButtonClick = () => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      trackEvent('tap_btn_engage', {
        ...properties,
        funnel: 'engage',
      })
    })()

    if (onClick) {
      onClick()
    } else if (data.link) {
      window.open(data.link, '_blank')
    } else {
      setShow(true)
    }
  }
  if (data && Object.keys(data).length !== 0) {
    const ctaContainerClassName = `${styles.cardCta} ${styles[data?.ctaType]}`

    return (
      <button
        className={ctaContainerClassName}
        type="button"
        onClick={() => {
          onButtonClick()
        }}>
        <span>{data.name}</span>
      </button>
    )
  }
  return null
}

export default NColumnGridCta
